import React from 'react';

import { ISCBImage } from 'types/interfaces/sulu/IContentBlocks';

const Image = ({ content }: ISCBImage) => (
  <img src={content.url} alt={content.name} />
);

export default Image;
